import { ManagerRole } from '../../../../hooks/auth/usePermissions';

export default {
  [ManagerRole.SuperAdmin]: 'Superadmin',
  [ManagerRole.Admin]: 'Admin',
  [ManagerRole.SalesManager]: 'Gerente de ventas',
  [ManagerRole.SalesLeadership]: 'Dirección de ventas',
  [ManagerRole.ContentManager]: 'Gestor de contenido',
  [ManagerRole.OnboardingManager]: 'Gestor de incorporación',
  [ManagerRole.OccAgent]: 'Agente de call center',
};
